var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"breadcrumbs",style:({ 'color' : _vm.colorBreadcrumb, 'fill': _vm.colorBreadcrumb })},_vm._l((_vm.$route.meta.breadcrumbs),function(route,index){return _c('li',{key:index},[_c('breadcrumb',{attrs:{"route":route,"disabled":index == _vm.$route.meta.breadcrumbs.length-1}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }